import { TenantTheme } from '../tenants/unbrace';

const getBadgeTheme = (theme: TenantTheme) => ({
  background: {
    danger: theme.palette.danger.shade1,
    primary: theme.palette.primary.shade0,
    secondary: theme.palette.neutral.shade1,
    success: theme.palette.success.shade1,
    warning: theme.palette.warning.shade1,
    tertiary: '#ffd9b7',
  },
  color: {
    danger: theme.palette.danger.shade4,
    primary: theme.palette.primary.shade10,
    secondary: theme.palette.neutral.shade6,
    success: theme.palette.success.shade5,
    warning: theme.palette.warning.shade9,
    tertiary: '#aa3b02',
  },
  padding: {
    main: '6px 23px',
    large: '10px 20px',
    small: '4px 14px',
  },
  fontSize: {
    main: '13px',
    xsmall: '10px',
  },
  borderRadius: {
    main: '25px',
  },
  fontWeight: {
    main: 500,
  },
});

export default getBadgeTheme;
